import { useEffect, useRef, useState } from 'react';
import TeamMemberCard from '../ui/TeamMemberCard';
import ButtonFill from '../ui/ButtonFill';
import gsap from 'gsap';
import TeamPOPUP from '../ui/TeamPOPUP';
import cmsClient from "@/lib/cmsClient"
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import { useRouter } from 'next/router';


const AboutTeam = ({ title, items, totalItemsCount , teamBtnText, infoTitles }) => {

 const [openPopUp, setOpenPopUp] = useState(false)
 const [popUpIndex, setPopUpIndex] = useState(0)
 const [teamShowedItems, setTeamShowedItems] = useState(items)
  const [loading, setLoading] = useState(false);
  const router = useRouter()
  const { locale } = router
  const cardsRefs = useRef([]);
  const sectionRef = useRef(null)
  const titleRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(()=> {
     setTeamShowedItems(items)
  }, [])

useEffect(() => {
  const mm = gsap.matchMedia();

  const localAnimations = [];
  const localTriggers = [];

  if (teamShowedItems.length > 6) {
    return () => {
      mm.revert();
    };
  }

  mm.add("(min-width: 1280px)", () => {
    const containerTween = gsap.fromTo(
      containerRef.current,
      { y: "13rem" },
      {
        y: 0,
        ease: "none",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top bottom",
          end: "top 60%",
          scrub: 0.1,
        },
      }
    );
    localAnimations.push(containerTween);
    localTriggers.push(containerTween.scrollTrigger);

    const titleTween = gsap.fromTo(
      titleRef.current,
      { opacity: 0 },
      {
        opacity: 1,
        duration: 1,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 60%",
        },
      }
    );
    localAnimations.push(titleTween);
    localTriggers.push(titleTween.scrollTrigger);

    const offsetsGroup1 = [20, 10, 40];
    const offsetsGroup2 = [10, 30, 20];

    cardsRefs.current.slice(0, 3).forEach((item, index) => {
      const tween = gsap.fromTo(
        item,
        { y: `${offsetsGroup1[index] ?? 0}rem` },
        {
          y: 0,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 80%",
            end: "top 40%",
            scrub: 0.5,
          },
        }
      );
      localAnimations.push(tween);
      localTriggers.push(tween.scrollTrigger);
    });

    cardsRefs.current.slice(3, 6).forEach((item, index) => {
      const tween = gsap.fromTo(
        item,
        { y: `${offsetsGroup2[index] ?? 0}rem` },
        {
          y: 0,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "center 80%",
            end: "center 40%",
            scrub: 0.5,
          },
        }
      );
      localAnimations.push(tween);
      localTriggers.push(tween.scrollTrigger);
    });
  });

  return () => {
    mm.revert();
    localAnimations.forEach(anim => anim?.kill());
    localTriggers.forEach(trigger => trigger?.kill());
  };
}, [teamShowedItems.length]);


const getMoreTeam = async () => {
  if (!loading) {

      const params = {
        per_page: teamShowedItems.length + 6,
        lang: locale
      };

    const queryString = new URLSearchParams(params).toString();
    
    try {
      const res = await cmsClient(`/team?${queryString}`);

    setLoading(true)
      setTeamShowedItems(res);

      setTimeout(() => {
        ScrollTrigger.refresh();
      }, 300);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false)
    }
  }

};
  
  return (
    <section ref={sectionRef} className="container-max py-[4rem] md:pb-[6rem] lg:pb-[8rem] xl:pb-[10rem] relative container-padding">

      <TeamPOPUP infoTitles={infoTitles} setOpenPopup={setOpenPopUp} popUpIndex={popUpIndex} popUpData={teamShowedItems} openPopUp={openPopUp}/>

      <div ref={containerRef} className=''>
    
      <h2
        ref={titleRef}
        className="[&>.selected]:italic lg:max-w-[86.5rem] heading-3 xl:max-w-[104rem] [&>.selected]:text-dusty-green-dark text-dark-blue mb-[3.2rem] md:mb-[4rem] xl:mb-[6rem]"
        dangerouslySetInnerHTML={{ __html: title }}
      />


      {/* <div className="grid md:grid-cols-2 lg:hidden mb-[3.2rem] md:mb-[4rem] xl:mb-[6rem] lg:grid-cols-[27.08%_45.84%_27.08%] gap-x-[2rem] gap-y-[2rem] md:gap-x-[1.6rem] md:gap-y-[3.2rem] lg:gap-x-0 lg:gap-y-[6rem]">
        {items.map((item, index) => {
            const isMiddleCol = index % 3 === 1;
            const row = Math.floor(index / 3);

            return (
              <div
                key={index}
                className={`w-full
                  ${isMiddleCol
                    ? row % 2 === 0
                      ? "lg:mr-auto lg:max-w-[59.1%] lg:ml-[4rem]"
                      : "lg:ml-auto lg:max-w-[59.1%] lg:mr-[4rem]"
                    : ""}
                `}
              >

                  <TeamMemberCard
                    index={index}
                    setPopUpIndex={setPopUpIndex}
                    setOpenPopUp={setOpenPopUp}
                    photoSmallUrl={item.image.url}
                    name={item.title}
                    role={item.acf.position}
                  />

              </div>
            );
          })}
      </div> */}
      
<div
  className="grid md:grid-cols-2 lg:grid-cols-[27.08%_45.84%_27.08%]
             mb-[3.2rem] md:mb-[4rem] xl:mb-[6rem]
             gap-x-[2rem] gap-y-[3.2rem]
             md:gap-x-[1.6rem] md:gap-y-[3.2rem]
             lg:gap-x-0 lg:gap-y-[6rem]"
>
  {teamShowedItems.map((item, index) => {
    const isMiddleCol = index % 3 === 1;
    const row = Math.floor(index / 3);

    return (
      <div
        key={index}
        ref={(el) => {
            if (el) {
              cardsRefs.current[index] = el;
            }
          }}
        className={`w-full
          ${
            isMiddleCol
              ? row % 2 === 0
                ? "lg:mr-auto lg:max-w-[59.1%] lg:ml-[4rem]"
                : "lg:ml-auto lg:max-w-[59.1%] lg:mr-[4rem]"
              : ""
          }`}
      >
        <TeamMemberCard
          index={index}
          setPopUpIndex={setPopUpIndex}
          setOpenPopUp={setOpenPopUp}
          photoSmallUrl={item?.image?.url}
          name={item.title}
          role={item.acf?.position}
          alt={item?.image?.alt}
        />
      </div>
    );
  })}
</div>


{(totalItemsCount > 6 && (teamShowedItems.length < totalItemsCount)) ? <ButtonFill onClick={()=> {getMoreTeam()}} className='md:w-[23.8rem] lg:mx-auto text-nowrap lg:w-[25.8rem]'>
        {teamBtnText}
        <img
          loading='lazy'
          fetchPriority='low'
          className="ml-[1.2rem] rotate-90"
          src="/images/arrow_right.svg"
          alt="Стрелка вправо"
        />
      </ButtonFill> : null}

            </div>
    </section>
  );
};

export default AboutTeam;